// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Options__Loading__3bWoh","Pending":"Options__Pending__2MXIE","JudgeImage":"Options__JudgeImage__VMgu6","loading":"Options__loading__3mGTu","SectionTitle":"Options__SectionTitle__3CPUg","OptionsTitle":"Options__OptionsTitle__2UeeW","Forward":"Options__Forward__3VhFe","Note":"Options__Note__29xsQ","Users":"Options__Users__1H-8F"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Stage/Options/Options.css
// module id = 396
// module chunks = 0